/**
 * @desc 分页条件查询节假日列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.HolidayManagementListResponseDto>
>;
export function request(
  body: defs.basics.HolidayManagementRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/holidayManagement/page`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
